var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 22H4l0 0c-1.72-.07-3.07-1.52-3-3.23v-7.54l0 0C.93 9.51 2.28 8.06 4 8h22l0 0c1.71.06 3.06 1.51 3 3.23v7.54l0 0c.06 1.71-1.29 3.16-3 3.23h-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.96 29L8.04 29l1.99-12 9.94 0 1.99 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8l0-7L10 1l0 7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M24.5 12a.5.5 0 1 0 0 1 .5.5 0 1 0 0-1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintOutline);
export default __webpack_public_path__ + "static/media/print-outline.5d1fabda.svg";
export { ForwardRef as ReactComponent };